<app-toolbar class="w-100-percent"></app-toolbar>
<div class="p-20 pt-30">
  <div class="flex flex-row gap-8 pb-20">
    <ng-container *ngFor="let tile of insightTiles">
      <div class="card p-16">
        <div class="flex flex-row">
          <div class="pr-8">
            <mat-icon *ngIf="tile.key !== DeployStatus.DEPLOYING" [svgIcon]="tile.icon" class="icon-md-1 mr-6"></mat-icon>
            <span *ngIf="tile.key === DeployStatus.DEPLOYING" class="icon-md-1 mr-6 icon" [ngClass]="{'rotating': tile.count > 0}"></span>
          </div>
          <div class="flex flex-col">
            <div *ngIf="tile.loading" class="skeleton mb-4"></div>
            <div *ngIf="!tile.loading" class="mat-headline-6 mb-4">{{ tile.count }}</div>
            <div>{{tile.title | transloco}}</div>
          </div>
        </div>
        <div class="fw-600 pt-16 cursor-pointer" *ngIf="tile.link" (click)="viewDetails(tile.link)">{{'TENANT_DASHBOARD.VIEW_DETAILS' | transloco}}</div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!isTenantFailed" class="tenant-section p-20">
    <span class="pr-16 fw-700">{{'TENANT_DASHBOARD.SELECT_TENANT' | transloco}}</span>
    <mat-select class="tenant-dropdown fw-500 fs-16 mr-24 pt-0 pr-0" [placeholder]="" [(value)]="selectedTenant" panelClass="tenant-dropdown-options" (selectionChange)="tenantSelectionChanged($event.value)">
      <mat-option *ngFor="let tenant of tenantsList" [value]="tenant" [title]="tenant.tenantId">{{ tenant.tenantId }}</mat-option>
    </mat-select>
  </div>
  <div *ngIf="isTenantFailed" class="flex justify-center items-center tenant-section pt-48 pb-48 mt-20">
    {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
  </div>

  <div class="flex flex-row gap-8 pt-20">
    <div class="p-20 chart-sections">
      <div class="flex flex-row pb-20">
        <mat-icon svgIcon="account_balance" class="icon-md mr-6"></mat-icon>
        <span class="fw-600">{{'TENANT_DASHBOARD.INSTANCE_COUNT_ENVIRONMENT' | transloco}}</span>
      </div>
      <div class="mb-18">
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="!isInstanceFailed" class="table-section">
        <table mat-table [dataSource]="instanceByClass" class="w-100-percent">
          <ng-container matColumnDef="name">
            <th mat-header-cell class="fs-14" *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element; let i = index">{{i+1}}<span class="ml-100">{{element.name}}</span></td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell class="fs-14" *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">{{element.value}} </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: datazoneColumns;"></tr>
        </table>
      </div>
      <div *ngIf="isInstanceFailed" class="flex justify-center items-center p-20 table-section">
        {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
      </div>
    </div>
    <div class="p-20 chart-sections">
      <div class="flex flex-row pb-8">
        <mat-icon svgIcon="incomplete_circle" class="icon-md mr-6"></mat-icon>
        <span class="fw-600">{{'TENANT_DASHBOARD.INSTANCE_BY_STATUS' | transloco}}</span>
      </div>
      <div *ngIf="!isInstanceFailed" echarts [options]="instanceBySolutionPiechart" class="chart-dimension instance-chart "></div>
      <div *ngIf="isInstanceFailed" class="flex justify-center items-center p-20 table-section">
        {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
      </div>
    </div>
  </div>
  <div class="flex flex-row gap-8 pt-20">
    <div class="p-20 chart-sections">
      <div class="flex flex-row pb-20">
        <mat-icon svgIcon="incomplete_circle" class="icon-md mr-6"></mat-icon>
        <span class="fw-600">{{'TENANT_DASHBOARD.INSTANCE_BY_DATAZONE' | transloco}}</span>
      </div>
      <div class="mb-18">
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="!isInstanceFailed" class="table-section">
        <table mat-table [dataSource]="instanceByDatazone" class="w-100-percent">
          <ng-container matColumnDef="name">
            <th mat-header-cell class="fs-14" *matHeaderCellDef>{{'TENANT_DASHBOARD.DATA_ZONE' | transloco}}</th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell class="fs-14" *matHeaderCellDef>{{'TENANT_DASHBOARD.COUNT' | transloco}}</th>
            <td mat-cell *matCellDef="let element"> {{element.value}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="datazoneColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: datazoneColumns;"></tr>
        </table>
      </div>
      <div *ngIf="isInstanceFailed" class="flex justify-center items-center p-20 table-section">
        {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
      </div>
    </div>
    <div class="p-20 chart-sections">
        <div class="flex flex-row justify-between items-center">
          <div class="flex flex-row pb-8">
            <mat-icon svgIcon="show_chart" class="icon-md-1 mr-6"></mat-icon>
            <span class="fw-600">{{'TENANT_DASHBOARD.INSTANCE_BY_MONTH' | transloco}}</span>
          </div>
          <mat-select *ngIf="!isInstanceFailed" class="year-dropdown fw-500 fs-16 mr-24 pt-0" [placeholder]="" [(value)]="selectedYear" panelClass="tenant-dropdown-options" (selectionChange)="yearSelectionChanged($event.value)">
            <mat-option *ngFor="let year of yearDropdown" [value]="year">{{ year }}</mat-option>
          </mat-select>
        </div>
        <div *ngIf="!isInstanceFailed" echarts [options]="instanceByMonthChart" class="chart-dimension"></div>
        <div *ngIf="isInstanceFailed" class="flex justify-center items-center p-20 table-section">
          {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
        </div>
      </div>
  </div>
</div>